import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import '../assets/css/home.css';
import { RouteComponentProps } from 'react-router';
import appConfigs from '../../../../config.json';
import StaticImageSlider from '../../../../components/StaticImageSlider';
import { IUserState } from '../../../../store/reducers/userReducer';
import flowimg from '../assets/img/bg.jpg';
import mhi from "../assets/img/slider-dec-v3.png";
import Footer from '../Footer';
import ImageSlider from '../../../../components/ImageSlider';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import { Box } from '@material-ui/core';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Header from '../Header';
type thisProps = RouteComponentProps;
interface PageState {
  showComponenrt: boolean;
  SelectedTabValue: string;


}

class About extends React.Component<thisProps, PageState> {
  constructor(props) {
    super(props);
    this.state = {
      showComponenrt: false,
      SelectedTabValue: "1",

    };
  }
  public async componentDidMount() {
    document.title =  appConfigs.CompanyTitle;

  }

  public render() {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      this.setState({ SelectedTabValue: newValue });
    };
    /*  const [name, setName] = useState("555"); */
    //  const userJwt = useSelector((state: IAppState) => state.UserState?state.UserState.jwt:null); -fluid-inner
    return (
      <div dir='ltr' id='page-about' >
   <Header />
 
        <main id="main">

 
          <section id="about" className="about">
            <div className="container" data-aos="fade-up">
              <div className="row gx-0">
                <div className="col-lg-7 f-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div className="content">
                   
                    <h3> شرکت  تجارت الکترونیک هوشمند تمدن
</h3>
<span style={{fontSize:"13px",paddingRight:"5px",paddingTop:"3px"}}> 
(دانش بنیان)</span>

                    <h2> </h2>
                    <p>
                      متشکل از تیمی نخبه و جوانانی متخصص در حوزه فناوری اطلاعات، بازار سرمایه و سیستم بانکی است که راهکارها و حل مشکلات نهادهای مالی، شرکت ها، کارگزاری ها، صندوق های سرمایه گذاری و ... را در خصوص حوزه پرداخت فراهم کرده است.

                    </p>
                    <div className="text-center text-lg-start">
                    <img src={require("../assets/img/d-460x460.png")} className="img-dfluid" style={{width:"128px"}}  alt="" />
                    <img src={require("../assets/img/sh-460x460.png")} className="img-dfluid" style={{width:"128px"}} alt="" />
                    <img src={require("../assets/img/s-460x460.png")} className="img-dfluid" style={{width:"128px"}}  alt="" />
                  
                    </div> 
                  </div>
                </div>
                <div className="col-lg-5 f-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
                  <img src={require("../assets/img/about.png")} className='about-img'   style={{height:"360px"}}/>
                </div>
              </div>
              <div>
                
  
              </div>
            </div>
          </section>

          <section id="values" className="values">

            <div className="container" data-aos="fade-up">

              <header className="section-header">
                <p style={{ textAlign: "center" }}>ارزش های سازمانی
                </p>
                <br />
                <h2 dir="rtl"> در شرکت تجارت الکترونیک هوشمند تمدن ارزش ها شالوده سازمان ما را تشکیل می دهند و در این راستا حرکت می‌کنیم.  
                </h2>
                <br />
                <h2 dir="rtl">

                  ما به حفظ بالاترین استانداردها و ارایه خدمات استثنایی و هم چنین پذیرش نوآوری معتقدیم.
                  این ارزش ها اعتماد را میان ما و شما شکل می‌دهد.
                </h2>
              </header>

              <div className="row">

                <div className="col-lg-3" data-aos="fade-up" data-aos-delay="200">
                  <div className="box">
                    <img src={require("../assets/img/values-1.png")} className="img-fluid" alt="" />
                    <h3>مشتری مداری
                    </h3>
                    <p>مشتریان ما در قلب هر کاری که انجام می دهیم قرار دارند. ما به درک نیازهای آن‌ها، ارائه راه‌حل‌های شخصی‌سازی‌شده، و ارائه خدمات استثنایی فراتر از انتظارات اختصاص داده شده‌ایم.

                    </p>
                  </div>
                </div>

                <div className="col-lg-3 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="400">
                  <div className="box">
                    <img src={require("../assets/img/values-2.png")} className="img-fluid" alt="" />
                    <h3>تمامیت</h3>
                    <p>ما با نهایت صداقت، شفافیت و رفتار اخلاقی رفتار می کنیم. ما معتقدیم که آنچه را که برای مشتریان، همکاران و ذینفعان ما درست است، انجام دهیم، حتی زمانی که با انتخاب های دشواری روبرو هستیم.

                    </p>
                  </div>
                </div>

    
                <div className="col-lg-3 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="600">
                  <div className="box">
                    <img src={require("../assets/img/values-3.png")} className="img-fluid" alt="" />
                    <h3>همکاری
                    </h3>
                    <p>
                      ما یک محیط کاری مشترک و فراگیر را پرورش می دهیم که در آن کار تیمی و تنوع مورد تجلیل قرار می گیرد. با استفاده از نقاط قوت و دیدگاه‌های منحصربه‌فرد کارکنان خود، نوآوری را هدایت می‌کنیم و با هم به موفقیت بیشتری دست می‌یابیم.


                    </p>
                  </div>
                </div>
                <div className="col-lg-3 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="600">
                  <div className="box">
                    <img src={require("../assets/img/values-4.png")} className="img-fluid" alt="" />
                    <h3>نوآوری</h3>
                    <p> ما تغییرات را می پذیریم و دائماً به دنبال راه حل های نوآورانه برای پاسخگویی به نیازهای در حال رشد مشتریان خود هستیم. ما کارمندان خود را تشویق می کنیم که خلاقانه فکر کنند، راهکار را به چالش بکشند و ایده های جدید را برای پیشبرد آینده بانکداری کشف کنند.

                    </p>
                  </div>
                </div>
              </div>

            </div>

          </section>
 
 
  
 
        </main>
        <Footer />
      </div>
    );
  };
}
export default connect()(About);
